<template>
  <m-demo-box demo-option="intrestsPurchasing">
       <template v-if="isMobile">
    <b-container fluid>
        <m-demo-select :propDemoType = "2" :specialDemoCategory = "3"></m-demo-select>
    </b-container>
    </template>
    <template v-else>
    <div class="mt-4">
      <m-demo-all-check />
    </div>
    <b-container fluid>
        <m-demo-select-p-c :propDemoType = "2" :specialDemoCategory = "3"></m-demo-select-p-c>
    </b-container>
    </template>
  </m-demo-box>
</template>

<script>
  import MDemoAllCheck from '@/components/demo/MDemoAllCheck'
  import MDemoBox from '@/components/demo/MDemoBox'
  import MDemoSelect from '@/components/demo/MDemoSelect'
  import MDemoSelectPC from '@/components/demo/MDemoSelectPC'
  export default {
    components: {
      MDemoBox,
      MDemoSelect,
      MDemoAllCheck,
      MDemoSelectPC
    },
    data () {
      return {
        selectColumn: null
      }
    },
    computed:{
      isMobile () {
        return this.$store.state.config.isMobile
      }
    },
    created () {
      // this.$store.dispatch('demo/init')
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .box {
    width: 100%
  }
  .all-hosehodls {
    margin-top: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/order/DemoIntrestsPurchasing.vue